import { useRef } from 'react';

interface CategoryItem {
  name: string;
  sublabel: string;
  count: string;
  url: string;
  image: string;
}

const categories: CategoryItem[] = [
  {
    name: 'Shoes',
    sublabel: 'Sneakers & Trainers',
    count: '200+',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20stylish%20white%20sneakers%20placed%20on%20a%20warm%20terracotta%20surface%2C%20afternoon%20sunlight%20casting%20long%20soft%20shadows%2C%20lifestyle%20product%20photography%20with%20a%20small%20potted%20plant%20in%20background%2C%20minimalist%20composition%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-01-shoes&orientation=squarish'
  },
  {
    name: 'Hoodies/Sweaters',
    sublabel: 'Warm & Cozy',
    count: '150+',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=An%20oversized%20knit%20sweater%20draped%20over%20a%20vintage%20wooden%20chair%20in%20a%20sunlit%20corner%2C%20warm%20golden%20hour%20light%20streaming%20through%20a%20nearby%20window%2C%20cozy%20editorial%20photography%20style%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-02-hoodie&orientation=squarish'
  },
  {
    name: 'T-Shirts',
    sublabel: 'Casual & Graphic',
    count: '180+',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20vintage%20wash%20t%20shirt%20on%20a%20light%20concrete%20surface%2C%20bright%20natural%20side%20lighting%20creating%20dramatic%20shadows%2C%20modern%20minimalist%20product%20photography%2C%20fabric%20texture%20clearly%20visible%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-03-tshirt&orientation=squarish'
  },
  {
    name: 'Jackets',
    sublabel: 'Outerwear & Layers',
    count: '120+',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20classic%20bomber%20jacket%20displayed%20on%20a%20minimalist%20metal%20rack%20against%20an%20exposed%20brick%20wall%2C%20urban%20loft%20atmosphere%2C%20soft%20overhead%20track%20lighting%2C%20editorial%20fashion%20photography%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-04-jacket&orientation=squarish'
  },
  {
    name: 'Pants/Shorts',
    sublabel: 'Bottoms & Denim',
    count: '160+',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20cargo%20pants%20laid%20flat%20on%20a%20polished%20concrete%20floor%2C%20top%20down%20view%2C%20bright%20even%20studio%20lighting%2C%20crisp%20editorial%20product%20photography%2C%20pocket%20and%20seam%20details%20visible%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-05-pants&orientation=squarish'
  },
  {
    name: 'Headwear',
    sublabel: 'Caps & Beanies',
    count: '90+',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20snapback%20cap%20resting%20on%20a%20stack%20of%20fashion%20magazines%20on%20a%20coffee%20table%2C%20soft%20ambient%20living%20room%20lighting%2C%20lifestyle%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-06-cap&orientation=squarish'
  },
  {
    name: 'Sets',
    sublabel: 'Matching Outfits',
    count: '70+',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20coordinated%20two%20piece%20outfit%20displayed%20on%20a%20minimalist%20clothing%20form%20against%20a%20soft%20beige%20backdrop%2C%20professional%20studio%20lighting%2C%20clean%20fashion%20editorial%20style%2C%20matching%20neutral%20earth%20tones%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-07-set&orientation=squarish'
  },
  {
    name: 'Underwear/Underpants',
    sublabel: 'Essentials',
    count: '100+',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20essentials%20neatly%20folded%20inside%20an%20open%20drawer%20with%20a%20warm%20wood%20interior%2C%20gentle%20natural%20light%20from%20above%2C%20minimalist%20lifestyle%20photography%2C%20clean%20and%20inviting%20composition%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-08-underwear&orientation=squarish'
  },
  {
    name: 'Jersey',
    sublabel: 'Sports & Teams',
    count: '130+',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20sports%20jersey%20displayed%20flat%20on%20a%20dark%20locker%20room%20bench%2C%20dramatic%20overhead%20spotlight%20effect%2C%20athletic%20product%20photography%2C%20high%20contrast%20lighting%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-09-jersey&orientation=squarish'
  },
  {
    name: 'Accessories',
    sublabel: 'Complete Your Look',
    count: '140+',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20wristwatch%20and%20bracelet%20arranged%20on%20a%20dark%20slate%20surface%2C%20soft%20directional%20lighting%20highlighting%20metallic%20textures%2C%20luxury%20product%20photography%2C%20elegant%20minimal%20composition%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-10-accessory&orientation=squarish'
  },
  {
    name: 'Bags',
    sublabel: 'Backpacks & Totes',
    count: '110+',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20premium%20leather%20tote%20bag%20standing%20on%20a%20light%20oak%20parquet%20floor%2C%20near%20a%20large%20window%20with%20sheer%20curtains%2C%20soft%20filtered%20daylight%2C%20elegant%20editorial%20product%20photography%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-11-bag&orientation=squarish'
  },
  {
    name: 'Belts',
    sublabel: 'Premium Leather',
    count: '60+',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20handcrafted%20leather%20belt%20elegantly%20coiled%20on%20a%20dark%20walnut%20wood%20surface%2C%20warm%20candle%20light%20ambiance%2C%20luxurious%20product%20photography%2C%20rich%20texture%20details%20visible%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-12-belt&orientation=squarish'
  },
  {
    name: 'Perfumes',
    sublabel: 'Fragrances',
    count: '50+',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=An%20artisan%20glass%20perfume%20bottle%20on%20a%20mirror%20surface%20with%20fresh%20flower%20petals%20scattered%20around%2C%20soft%20romantic%20backlighting%2C%20luxury%20beauty%20product%20photography%2C%20dreamy%20atmosphere%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-13-perfume&orientation=squarish'
  },
  {
    name: 'Other Stuff',
    sublabel: 'More Finds',
    count: '80+',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=An%20artistic%20flat%20lay%20of%20miscellaneous%20fashion%20items%20including%20a%20silk%20scarf%20and%20keychain%20on%20a%20textured%20linen%20fabric%2C%20morning%20light%20from%20a%20skylight%2C%20creative%20editorial%20photography%2C%20no%20text%20or%20logos&width=500&height=500&seq=cat-new-14-other&orientation=squarish'
  },
];

export default function CategorySection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 300;
      scrollRef.current.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-2">
              Shop by <span className="text-primary-500">Category</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">Browse all 14 product categories from the VigorBuy spreadsheet</p>
          </div>
          <span className="hidden md:inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full whitespace-nowrap">
            14 Categories
          </span>
        </div>

        <div className="hidden md:flex items-center justify-end gap-2 mb-4">
          <button onClick={() => scroll('left')} className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-foreground-900/10 hover:bg-background-100 transition-colors cursor-pointer">
            <i className="ri-arrow-left-s-line text-foreground-700"></i>
          </button>
          <button onClick={() => scroll('right')} className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-foreground-900/10 hover:bg-background-100 transition-colors cursor-pointer">
            <i className="ri-arrow-right-s-line text-foreground-700"></i>
          </button>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto pb-4"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[200px] md:w-[220px] bg-white rounded-lg overflow-hidden group cursor-pointer hover:bg-white/90 transition-all duration-200"
              data-product-shop
            >
              <div className="aspect-square overflow-hidden bg-background-200/40">
                <img
                  src={cat.image}
                  alt={`${cat.name} VigorBuy spreadsheet category`}
                  title={`${cat.name} - VigorBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</p>
                  <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{cat.sublabel}</p>
                </div>
                <span className="text-lg font-heading font-bold text-primary-500 whitespace-nowrap ml-2">{cat.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}